(() => {
  const priceElemTimers = window.WeakMap ? new WeakMap() : new Map();
  window.swinger.i18n()
    .then((i18n) => {
      const update = (elem) => {
        window.clearTimeout(priceElemTimers.get(elem));
        priceElemTimers.set(elem, window.setTimeout(() => {
          const itemNumber = elem.getAttribute('data-itemnumber');
          let currentPrice = parseFloat(elem.getAttribute('data-currentprice'));
          let regularPrice = parseFloat(elem.getAttribute('data-regularprice'));
          const itemOwnState = window.swinger.user.getItemOwnState(itemNumber);
          const isAlreadyOwned = window.swinger.user.isLoggedIn() && ['purchased', 'rented'].indexOf(itemOwnState.status) > -1;
          let key = 'ui.price.text.default';

          switch (true) {
            default:
              break;

            case isAlreadyOwned:
              key = 'ui.price.text.own';
              break;

            case currentPrice < regularPrice:
              key = 'ui.price.text.sale';
              break;
          }

          currentPrice = window.swinger.currency.formatCurrency(currentPrice);
          regularPrice = window.swinger.currency.formatCurrency(regularPrice);

          let updatedText = i18n(key, {
            currentPrice,
            regularPrice,
          });

          updatedText = window.swinger.currency.reformatHTML(updatedText);

          elem.innerHTML = window.swinger.md(updatedText);
        }, 100));
      };

      window.swinger.observer.initialize('.swinger-price[data-itemnumber]', (elem) => {
        document.addEventListener('swinger.user:authchange', () => {
          update(elem);
        });

        document.addEventListener('swinger-widget:rendered', (e) => {
          const target = window.swinger.eventHub.getTarget(e);

          if (target.contains && !target.contains(elem)) {
            return;
          }

          update(elem);
        });

        update(elem);
      }, false);
    })
    .catch(console.info);
})();
